import axios from '../axios-auth'

export const customerSaleAnalysisReportService = {
  getCustomerSaleAnalysisReportByCategoryGroup,
  getCustomerSaleAnalysisReportByCategoryGroupPrint,
}

function getCustomerSaleAnalysisReportByCategoryGroup(searchParams, page, size, sortedBy) {
  if (!page) {
    page = 0;
  }
  else {
    page -= 1;
  }
  if (!size) {
    size = 50;
  }

  let params = {
    page: page,
    size: size,
    sort: sortedBy
  };

  if (searchParams.shopId) {
    params["shopId"] = searchParams.shopId;
  }
  if (searchParams.fromDate) {
    params["fromDate"] = searchParams.fromDate;
  }
  if (searchParams.toDate) {
    params["toDate"] = searchParams.toDate;
  }
  if (searchParams.customerIds) {
    params["customerIds"] = searchParams.customerIds.join();
  }
  if (searchParams.categoryGroupId) {
    params["categoryGroupId"] = searchParams.categoryGroupId;
  }

  return axios.get("/auth/customer-sale-analysis-report-by-category-group", { params });
}

function getCustomerSaleAnalysisReportByCategoryGroupPrint(searchParams) {
  let params = {};

  if (searchParams.fromDate) {
    params["fromDate"] = searchParams.fromDate;
  }
  if (searchParams.toDate) {
    params["toDate"] = searchParams.toDate;
  }
  if (searchParams.shopId) {
    params["shopId"] = searchParams.shopId;
  }
  if (searchParams.customerIds) {
    params["customerIds"] = searchParams.customerIds.join();
  }
  if (searchParams.categoryGroupId) {
    params["categoryGroupId"] = searchParams.categoryGroupId;
  }

  return axios.get("/auth/customer-sale-analysis-report-by-category-group-print", { params });
}
